// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jeiK","left":"styles_left__70LrT"};